import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { FaRegCircle } from 'react-icons/fa';
import { FiLock } from 'react-icons/fi';

import { theme } from '@style';

type NavLinkProps = {
  isActive: boolean;
};

const NavLink = styled(Link)<NavLinkProps>`
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  font-size: ${theme.fontSizes.lg};
  padding: 16px 24px;
  cursor: pointer;
  transition: 0.3 color;
  text-decoration: none;
  background-color: ${props => props.isActive && 'blue'};
  position: relative;

  &:hover {
    color: ${theme.palette.white};
  }

  &.active {
    color: ${theme.palette.white};

    &:before {
      content: '';
      width: 6px;
      background: rgba(235, 131, 14, 1);
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      box-shadow: 5px 0px 12px 0px rgba(235, 131, 14, 0.8);
    }
  }
`;

const Text = styled.p`
  padding-left: 16px;
`;

const NavItem = props => <NavLink {...props} activeClassName="active" />;

export const MainNavItems = () => {
  return (
    <ul>
      <NavItem to="/">
        <FaRegCircle />
        <Text>Projects</Text>
      </NavItem>
      <NavItem to="/personal-projects">
        <FiLock />
        <Text>Personal projects </Text>
      </NavItem>
    </ul>
  );
};

// export const NavItems = () => {
//   return (
//     <ul>
//       {navItems.map(item => (
//         <NavItem to={`/${item.route}`} key={item.name}>
//           <FaRegFolder />
//           <Text>{item.name}</Text>
//         </NavItem>
//       ))}
//     </ul>
//   );
// };
